import { CLOSE_SUB_MENU_PANEL_EVENT } from '../../../navigation-header/v1/js/navigation-header-events.js';

export default class NavigationPanelDestination extends CoreJS.BaseComponent {
  static CLASS_NAMESPACE = 'navigation-panel-destination';

  /** @inheritDoc */
  constructor(componentHost, componentName) {
    super(componentHost, componentName);
  }

  /** @inheritDoc */
  initialize() {
    this.level1Toggles = this.componentHost.querySelectorAll(
      '.ace-nav-panel-destination__menu-toggle',
    );
    this.level2Toggles = this.componentHost.querySelectorAll(
      '.ace-nav-panel-destination__submenu-toggle',
    );
    this.dropdownListLinks = this.componentHost.querySelectorAll(
      '.ace-nav-panel-destination__dropdown-list-link, .ace-nav-panel-destination__sub-list-link',
    );
    this.level1Entries = this.componentHost.querySelectorAll(
      `.ace-nav-panel-destination__cta, .ace-nav-panel-destination__link, .ace-nav-panel-destination__menu-toggle,
       .ace-nav-panel-destination__image-close, .ace-nav-panel-destination__panel-one > .ace-nav-panel-destination__mobile-back-button`,
    );
    this.mobileBackLevel2 = this.componentHost.querySelectorAll(
      '.ace-nav-panel-destination__panel-two > .ace-nav-panel-destination__mobile-back-button',
    );
    this.closeButton = this.componentHost.querySelector('.ace-nav-panel-destination__image-close');
    const [firstElement] = this.level1Toggles || [];
    
    this.currentLevel1 = firstElement;
    this.imageContainer = this.componentHost.querySelector(
      '.ace-nav-panel-destination__panel-three',
    );
    this.mainBackButton = this.componentHost.querySelector('.ace-nav-panel-destination__panel-one > .ace-nav-panel-destination__mobile-back-button');
    this.imageTogglesHover = this.componentHost.querySelectorAll('[data-image]:not(.ace-nav-panel-destination__menu-toggle)');
    this.imageTogglesClick = this.componentHost.querySelectorAll('.ace-nav-panel-destination__menu-toggle[data-image]');
    const firstEntry = this.imageTogglesClick?.[0];
    this.ANIMATION_DURATION = 200;
    setTimeout(() => {
      const level2Entries = this.currentLevel1?.nextElementSibling?.querySelectorAll(
        '.ace-nav-panel-destination__submenu-toggle, .ace-nav-panel-destination__dropdown-list-link',
      ) || [];
    
      level2Entries.forEach((el) => el.setAttribute('tabindex', '-1'));
      
      if (firstEntry) {
        this.setImage(this.getImageData(firstEntry));
        // eslint-disable-next-line no-unused-expressions
        firstEntry.nextElementSibling && (firstEntry.nextElementSibling.hidden = false);
      }
    }, 0);
    this.mainBackButton?.addEventListener('click', () => {
      this.handlePanelClose();
    });
    this.closeButton?.addEventListener('click', () => {
      this.handlePanelClose();
    });
    this.level1Toggles?.forEach((toggle) => {
      toggle.addEventListener('keydown', this.handleLevel1KeyDown.bind(this));
      toggle.addEventListener('click', () => {
        this.toggleLevel1(toggle);
      });
    });
    this.level1Entries?.forEach((toggle) => {
      const isExtended = toggle.classList.contains('ace-nav-panel-destination__link');
      toggle.addEventListener('keydown', (e) => {
        if (!isExtended) {
          this.imageContainer?.classList.remove('extended');
        }
        this.handleOtherLevel1KeyDown(e);
      });
      toggle.addEventListener('mouseover', () => {
        if (!isExtended) {
          this.imageContainer?.classList.remove('extended');
        }
      });
    });
    this.mobileBackLevel2?.forEach((button) => {
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.closeLevel1(button);
        }
      });
      button.addEventListener('click', () => {
        this.closeLevel1(button);
      });
    });
    this.level2Toggles?.forEach((toggle) => {
      toggle.addEventListener('keydown', this.handleLevel2KeyDown.bind(this));
      toggle.addEventListener('click', () => {
        this.toggleLevel3(toggle);
      });
    });
    this.dropdownListLinks?.forEach((toggle) => {
      toggle.addEventListener('keydown', this.handleLevel3KeyDown.bind(this));
    });
    this.imageTogglesHover?.forEach((toggle) => {
      toggle.addEventListener('mouseover', () => {
        this.setImage(this.getImageData(toggle));
      });
      toggle.addEventListener('focus', () => {
        this.setImage(this.getImageData(toggle));
      });
    });
    this.imageTogglesClick?.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        this.setImage(this.getImageData(toggle));
      });
      toggle.addEventListener('focus', () => {
        this.setImage(this.getImageData(toggle));
      });
    });
  }
  getImageData(entry) {
    return {
      url: entry.getAttribute('data-image'),
      text: entry.getAttribute('data-text'),
      entry
    };
  }
  setAriaExpanded(el, value) {
    el?.setAttribute('aria-expanded', value);
  }
  setImage(data) {
    const { url, text, entry } = data;
    const isExtended = entry?.classList.contains('ace-nav-panel-destination__link');
    if (isExtended) {
      this.imageContainer?.classList.add('extended');
    }
    this.imageContainer?.classList.remove('active');
    setTimeout(() => {
      requestAnimationFrame(() => {
        if (this.imageContainer) {
          this.imageContainer.style.setProperty(
            isExtended ? '--panel-background-image-ext' : '--panel-background-image',
            `url(${url})`,
          );
          // eslint-disable-next-line no-unused-expressions
          this.imageContainer.querySelector('.ace-nav-panel-destination__image-text') &&
            (this.imageContainer.querySelector('.ace-nav-panel-destination__image-text').textContent = text);
          this.imageContainer.classList.add('active');
        }
      });
    }, this.ANIMATION_DURATION);
  }
  handleLevel1KeyDown(e) {
    const { key, target: entry } = e;
    if (key === 'Enter') {
      e.preventDefault();
      this.toggleLevel1(entry);
    }
  }
  handleOtherLevel1KeyDown(e) {
    const { key } = e;
    const focusableElements = Array.from(this.level1Entries || []).filter(
      (el) => el.offsetParent !== null,
    );
    const currentIndex = focusableElements.indexOf(document.activeElement);

    if (key === 'ArrowDown' && currentIndex < focusableElements.length - 1) {
      e.preventDefault();
      focusableElements[currentIndex + 1].focus();
    } else if (key === 'ArrowUp' && currentIndex > 0) {
      e.preventDefault();
      focusableElements[currentIndex - 1].focus();
    }
  }
  closePreviousLevel1() {
    this.setAriaExpanded(this.currentLevel1, false);
    this.currentLevel1.parentElement?.querySelector('.ace-nav-panel-destination__panel-two')?.classList.remove('mobile-active');
    const currentLevel2Id = this.currentLevel1?.getAttribute('aria-controls');
    const currentLevel2 = currentLevel2Id && this.currentLevel1?.parentElement?.querySelector(`.ace-nav-panel-destination__panel-two`);
    // eslint-disable-next-line no-unused-expressions
    currentLevel2 && (currentLevel2.hidden = true);
    currentLevel2?.querySelectorAll('.ace-nav-panel-destination__submenu-toggle')
      .forEach((el) => {
        this.setAriaExpanded(el, false);
        el.setAttribute('hidden', true);
      });
    currentLevel2?.querySelectorAll('.ace-nav-panel-destination__dropdown-list')
      .forEach((el) => el.setAttribute('hidden', true));
  }
  closeLevel1(button) {
    this.setAriaExpanded(button, false);
    const panel2 = button.closest('.ace-nav-panel-destination__panel-two');
    panel2?.classList.remove('mobile-active');
    const toggleLevel1 = panel2?.previousElementSibling;
    this.setAriaExpanded(toggleLevel1, false);
    toggleLevel1?.focus();
    panel2?.querySelectorAll('.ace-nav-panel-destination__submenu-toggle, .ace-nav-panel-destination__sub-list-item > a')
      .forEach((el) => el.setAttribute('tabindex', '-1'));
  }
  toggleLevel1(button) {
    const isCurrent = this.currentLevel1 === button;
    if (!isCurrent) {
      this.closePreviousLevel1();
      this.currentLevel1 = button;
    }
    const expanded = button.getAttribute('aria-expanded') === 'true';
    const menuId = button.getAttribute('aria-controls');
    const menu = menuId && button.parentElement?.querySelector(`.ace-nav-panel-destination__panel-two`);
    
    if (!expanded) {
      menu?.classList.add('mobile-active');
      this.setAriaExpanded(button, true);
      menu?.removeAttribute('hidden');
      const level2Entries = menu?.querySelectorAll(
        '.ace-nav-panel-destination__submenu-toggle, .ace-nav-panel-destination__dropdown-list-link',
      ) || [];
      level2Entries.forEach((el) => el.removeAttribute('tabindex'));
      setTimeout(() => {
        level2Entries?.[0]?.focus();
      }, 0);
    } else {
      this.setAriaExpanded(button, false);
      button.focus();
      menu?.classList.remove('mobile-active');
      const level2Entries = menu?.querySelectorAll(
        '.ace-nav-panel-destination__submenu-toggle, .ace-nav-panel-destination__dropdown-list-link',
      );
      const level2Lists = menu?.querySelectorAll(
        '.ace-nav-panel-destination__dropdown-list',
      );
      const toggleLevel2 = menu?.querySelectorAll(
        '.ace-nav-panel-destination__submenu-toggle',
      );
      toggleLevel2?.forEach((el) => this.setAriaExpanded(el, false));
      level2Lists?.forEach((el) => (el.hidden = true));
      level2Entries?.forEach((el) => el.setAttribute('tabindex', '-1'));
    }
  }
  closeLevel2(link) {
    const list = link.closest('.ace-nav-panel-destination__dropdown-list');
    if (list) {
      list.hidden = true;
      const dropdownButton = list.previousElementSibling;
      this.setAriaExpanded(dropdownButton, false);
      dropdownButton?.focus();
    }
  }
  handleLevel2KeyDown(e) {
    const { key } = e;

    switch (key) {
      case 'Enter':
        e.preventDefault();
        this.toggleLevel3(e.target);
        break;
      case 'ArrowUp':
        e.preventDefault();
        this.closeLevel3(e.target);
        const previousEntry = e.target.closest('.ace-nav-panel-destination__sub-list-item')
          ?.previousElementSibling
          ?.querySelector(
            '.ace-nav-panel-destination__submenu-toggle, .ace-nav-panel-destination__dropdown-list-link',
          );
        if (previousEntry) previousEntry.focus();
        break;
      case 'ArrowDown':
        e.preventDefault();
        const nextEntry = e.target.closest('.ace-nav-panel-destination__sub-list-item')
          ?.nextElementSibling
          ?.querySelector(
            '.ace-nav-panel-destination__submenu-toggle, .ace-nav-panel-destination__dropdown-list-link',
          );
        nextEntry?.focus();
        break;
    }
  }
  toggleLevel3(button) {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    const dropdownId = button.getAttribute('aria-controls');
    const dropdownList = dropdownId && button.parentElement?.querySelector(".ace-nav-panel-destination__dropdown-list");
    
    if (expanded) {
      this.setAriaExpanded(button, false);
      if (dropdownList) dropdownList.hidden = true;
    } else {
      this.setAriaExpanded(button, true);
      if (dropdownList) {
        dropdownList.hidden = false;
        dropdownList.querySelector('li a')?.focus();
      }
    }
  }
  closeLevel3(button) {
    const dropdownId = button.getAttribute('aria-controls');
    const dropdownList = dropdownId && button.parentElement?.querySelector(".ace-nav-panel-destination__dropdown-list");
    
    this.setAriaExpanded(button, false);
    if (dropdownList) dropdownList.hidden = true;
  }
  handleLevel3KeyDown(e) {
    const { key, target: link } = e;
    if (key === 'ArrowDown') {
      e.preventDefault();
      const nextItem = link.parentElement?.nextElementSibling?.firstElementChild;
      if (nextItem) nextItem.focus();
    } else if (key === 'ArrowUp') {
      e.preventDefault();
      const previousItem = link.parentElement?.previousElementSibling?.firstElementChild;
      if (previousItem) previousItem.focus();
    }
  }
  handlePanelClose() {
    const closeEvent = new CustomEvent(CLOSE_SUB_MENU_PANEL_EVENT);
    document.dispatchEvent(closeEvent);
  }
}

// Registering component in component factory.
CoreJS.BaseComponent.registerComponent(
  NavigationPanelDestination.CLASS_NAMESPACE,
  NavigationPanelDestination,
);
